import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// The form to add or edit a section within a knowledge base group
const KnowledgeBaseSectionForm: React.FC<{ viewKey?: string, groupId?: number }> = ({ viewKey, groupId }) => {

    const apiObject = 'knowledge_base_section_as_superuser';

    // Plug in the fields and their properties
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'knowledge_base.section.name_label',
            type: 'text',
            placeholder: 'knowledge_base.section.name_placeholder',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={groupId ? { group: groupId } : undefined}
        />
    );
};

export default KnowledgeBaseSectionForm;
